import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import PlanRouteComponent from '@/features/plans/components/PlanRouteComponent'

export const Route = createFileRoute('/_authed/plans/')({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(convexQuery(api.plans.getPlans, {}))
  },
  pendingComponent: () => <LoadingScreen message="Loading plans..." />,
  component: PlansRouteWrapper,
})

function PlansRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading plans..." />}>
      <PlanRouteComponent />
    </Suspense>
  )
}
